import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { V12RetailFinanceComponentDef } from '@df/module-V12/v12-retail-finance.component.def';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { CheckoutFormComponent } from '../../checkout/form/checkout-form.component';
import { CheckoutStepComponent } from '../../checkout/step/checkout-step.component';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { MuiInputDirective } from '../legacy/forms/mui-input.directive';
import { V12RetailFinanceInfoComponent } from './v12-retail-finance-info.component';
interface IV12RetailFinanceInfoItem {
    title: string;
    value: number | string;
    isPrice?: boolean;
}
@Component({
    selector: 'v12-retail-finance',
    templateUrl: './v12-retail-finance.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: true,
    imports: [
        V12RetailFinanceInfoComponent,
        PriceComponent,
        CommonModule,
        TranslationModule,
        FormsModule,
        MuiInputDirective,
        InputWrapComponent,
        V12RetailFinanceInfoComponent,
        InputWrapBodyDirective
    ]
})
export class V12RetailFinanceComponent extends V12RetailFinanceComponentDef {
    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        _ref: ChangeDetectorRef,
        protected override scrollToService: ScrollToService,
        checkoutStepcomponent: CheckoutStepComponent
    ) {
        super(checkoutFormComponent, _ref, scrollToService, checkoutStepcomponent);
    }
    get infoItems(): IV12RetailFinanceInfoItem[] {
        if (this.info) {
            const {
                productName,
                totalAmount,
                depositAmount,
                loanAmount,
                interestRate,
                monthlyPayment,
                terms,
                creditAmount,
                totalAmountPayable
            } = this.info;
            return [
                { title: 'Product Name', value: productName },
                { title: 'Value of Goods', value: totalAmount, isPrice: true },
                { title: 'Amount of Deposit', value: depositAmount, isPrice: true },
                { title: 'Amount of Loan', value: loanAmount, isPrice: true },
                { title: 'Interest Rate', value: `${interestRate}%` },
                { title: 'Monthly Payment', value: monthlyPayment, isPrice: true },
                { title: 'Terms of agreement', value: terms },
                { title: 'Total Cost of Credit', value: creditAmount, isPrice: true },
                { title: 'Total Cost', value: totalAmountPayable, isPrice: true }
            ];
        }
        return [];
    }
    trackByInfoItemTitleValue(index: number, infoItem: IV12RetailFinanceInfoItem): string {
        return `${infoItem.title}_${infoItem.value}`;
    }

    override ngAfterViewInit(): void {
        super.ngAfterViewInit();
        let defaultOption = this.packOptions.find(packOption => packOption.months === 48);
        if (defaultOption) {
            this.packOptionId = defaultOption.id;
        }
    }

    asNumber(value: number | string): number {
        return typeof value === 'string' ? parseInt(value, 10) : value;
    }
}
